import { MediaQuery } from '@grandvisionhq/common';
import { getComponentByPath } from './get-component-by-path.js';
import { getContentByRef } from './get-content-by-ref.js';

function getPlpPromotionSize(pageModel, breakpoint) {
    var ref, ref1, ref2, ref3;
    if (!pageModel) {
        return {};
    }
    const mainComponent = getComponentByPath('main', pageModel);
    const catalogComponent = (ref1 = mainComponent === null || mainComponent === void 0 ? void 0 : (ref = mainComponent.components) === null || ref === void 0 ? void 0 : ref[0].components) === null || ref1 === void 0 ? void 0 : ref1.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (c)=>c.label === 'Product catalog v2'
    );
    if (!catalogComponent) {
        return {};
    }
    const ref4 = (ref2 = catalogComponent.models) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.document) === null || ref3 === void 0 ? void 0 : ref3.$ref;
    const content = getContentByRef(ref4, pageModel);
    const { smallPromotion , bigPromotion  } = content !== null && content !== void 0 ? content : {};
    const isSmallScreen = breakpoint === MediaQuery.BreakpointName.PHONE;
    const smallPromoSize = smallPromotion ? isSmallScreen ? 2 : 1 : 0;
    const bigPromoSize = bigPromotion ? 2 : 0;
    return {
        plpPromotionSize: smallPromoSize + bigPromoSize
    };
}

export { getPlpPromotionSize };
//# sourceMappingURL=get-plp-promotion-size.js.map
